import { useMutation, useQueryClient } from '@tanstack/react-query'
import { PlacesApi } from '@ulysses-inc/harami_api_client'
import { useSnackbar } from 'src/components/snackbar/useSnackbar'
import { baseClient } from 'src/state/middleware/saga/baseClient'
import {
  handleHTTPError,
  isHTTPError,
} from 'src/state/middleware/saga/handleHttpError'
import { placeGroupQueryKeys } from './queryKeys'

export type DeletePlaceGroupParams = {
  placeNodeId: string
}

export const useMutationDeletePlaceGroup = () => {
  const queryClient = useQueryClient()
  const { showErrorSnackbar } = useSnackbar()

  return useMutation({
    mutationFn: async (params: DeletePlaceGroupParams) => {
      return await baseClient
        .getApi(PlacesApi)
        .deletePlaceNode({ placeNodeId: params.placeNodeId })
        .catch(handleHTTPError)
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: placeGroupQueryKeys.all })
    },
    onError: (error: unknown) => {
      if (isHTTPError(error)) {
        showErrorSnackbar(error.errors.join('\n'))
      } else {
        showErrorSnackbar('現場グループの削除に失敗しました')
      }
    },
  })
}
